const ITEMS = [
  "Google Business Profile",
  "Local SEO",
  "Maps Visibility",
  "More Calls",
  "More Bookings",
  "Reviews That Sell",
  "Free Audit",
];

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-8 font-heading text-lg font-bold uppercase tracking-[0.18em] text-pine sm:text-xl">
          {item}
        </span>
        <span aria-hidden="true" className="h-2 w-2 rounded-full bg-pine/40" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="overflow-hidden border-y border-pine/10 bg-pine-light py-5"
  >
    <div className="marquee-track">
      <Strip />
      <Strip />
    </div>
  </div>
);
